import type { PropsWithChildren, ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shared-kernel/primary/shared/shadcn/ui/card";
import { Separator } from "@shared-kernel/primary/shared/shadcn/ui/separator";
import { cn } from "@components/utils/utils";

interface Props {
  title: string;
  headerChildren?: ReactNode;
  cardClassname?: string;
  headerChildrenPosition?: "right" | "below";
}

export const CustomCard = ({
  title,
  children,
  headerChildren,
  cardClassname,
  headerChildrenPosition = "right",
}: PropsWithChildren<Props>) => {
  return (
    <Card className={cn("w-full", cardClassname)}>
      <CardHeader
        className={cn("flex items-center", {
          "flex-row justify-between": headerChildrenPosition === "right",
          "flex-col items-start gap-2": headerChildrenPosition === "below",
        })}
      >
        <CardTitle>{title}</CardTitle>
        {headerChildren}
      </CardHeader>
      <Separator />
      <CardContent className="flex flex-col items-center pt-3 text-foreground">{children}</CardContent>
    </Card>
  );
};
